import {DoraProperty} from 'src/app/Decorators/Decorator';
import {TUPLA_TYPE} from 'src/app/DoraData/data-base';
import {DataTupla} from 'src/app/DoraData/data-tupla';
import {_TRANSLATE} from '../../../TranslationMarkers/TranslationMarkers';
import {TranslationService} from '../../../TranslationMarkers/translation.service';

export class Column {
  @DoraProperty
  private unitSx = '';

  @DoraProperty
  private name = '';

  @DoraProperty
  private unitDx = '';

  @DoraProperty
  private numberFormatter = '###,###,###,###.#';

  // value to display
  // tslint:disable-next-line:variable-name
  private _valueStr = '';

  // tslint:disable-next-line:variable-name
  private _finalValueNumber = 0.0;
  // tslint:disable-next-line:variable-name
  private _currentValue: DataTupla = null;

  // tslint:disable-next-line:variable-name
  private _numberOfSteps = 10.0;

  private step = 100;

  // tslint:disable-next-line:variable-name
  private _translationService: TranslationService = null;

  // tslint:disable-next-line:variable-name
  private _tooltipVisible = false;

  get tooltipVisible(): boolean {
    return this._tooltipVisible;
  }

  set tooltipVisible(value: boolean) {
    this._tooltipVisible = value;
  }

  set translationService(value: TranslationService) {
    this._translationService = value;
  }

  get numberOfSteps(): number {
    return this._numberOfSteps;
  }

  set numberOfSteps(value: number) {
    this._numberOfSteps = value;
    if (this.finalValueNumber !== 0) {
      this.step = Math.abs(this.finalValueNumber) / value;
    }
  }

  get Name(): string {
    return this.name;
  }

  get TranslatedName(): string {
    if (this._translationService !== null) {
      return this._translationService.get(this.name);
    }
    return this.name;
  }
  get valueStr(): string {
    return this._valueStr;
  }

  set valueStr(value: string) {
    this._valueStr = value;
  }

  get finalValueNumber(): number {
    return this._finalValueNumber;
  }

  set finalValueNumber(value: number) {
    this._finalValueNumber = value;
  }


  get currentValue(): DataTupla {
    return this._currentValue;
  }

  set currentValue(value: DataTupla) {
    this._currentValue = value;
    if (this.currentValue.Type === TUPLA_TYPE.NUMBER) {
      this.finalValueNumber = this.currentValue.Value;
      this.currentValue.Value = 0.0;
    }

    // set value translated if necessary
    this.valueStr = this.currentValue.getTrimmedValue('-', this.numberFormatter, this._translationService);
  }

  /**
   * Increment value if necessary
   * @return true = reached the value;
   */
  public incrementValue(): boolean {
    if (this.currentValue.Type !== TUPLA_TYPE.NUMBER) {
      return true;
    }

    let flReachedEnd = false;

    if (this.finalValueNumber < 0) {
      // negative number
      this.currentValue.Value -= this.step;
      if (this.currentValue.Value < this.finalValueNumber) {
        this.currentValue.Value = this.finalValueNumber;
        flReachedEnd = true;
      }
    } else {
      // positive number
      this.currentValue.Value += this.step;
      if (this.currentValue.Value > this.finalValueNumber) {
        this.currentValue.Value = this.finalValueNumber;
        flReachedEnd = true;
      }
    }

    this.valueStr = this.currentValue.getFormattedValue('-', this.numberFormatter);
    return flReachedEnd;
  }

  get UnitSx(): string {
    return this.unitSx;
  }
  get UnitDx(): string {
    return this.unitDx;
  }
}
